/* eslint-disable import/prefer-default-export */

import { createSortText } from "aegion_common_utilities/lib/Sort";

export const sortCustomers = createSortText('ASC', { getValue: (u) => u?.name });
